import {NgModule} from '@angular/core'
import {ContentSectionModule} from '../../../../craft/content-section/content-section.module'
import {RouterModule} from '@angular/router'
import {CommonModule, NgOptimizedImage} from '@angular/common'
import {SupportSectionComponent} from './support-section.component'
import {FontAwesomeModule} from '@fortawesome/angular-fontawesome'
import {PipesModule} from '../../../pipes/pipes.module'
import {SupportPortraitComponent} from '../../../../craft/support/support-portrait/support-portrait.component'
import {SupportBoxModule} from '../../../../craft/support/support-box/support-box.module'

@NgModule({
  declarations: [SupportSectionComponent],
  imports: [
    CommonModule,
    ContentSectionModule,
    SupportBoxModule,
    RouterModule,
    FontAwesomeModule,
    PipesModule,
    SupportPortraitComponent,
    NgOptimizedImage,
  ],
  exports: [SupportSectionComponent],
})
export class SupportSectionModule {}
